import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';

type Props = {
  content: CmsApiDocument;
};

export function getContentListingCounts({
  content,
}: Props): Record<string, number> | undefined {
  return content.heroSearch?.listingCounts;
}
